<template>
  <div class="m1-page">
    <!-- Hero Section -->
    <section class="page-content">
      <div class="title-box">
        <p class="text_9">technological revolution</p>
        <p class="text_10 m1-main-title">M1 body composition analyzer</p>
      </div>
      
      <div class="features-box" data-wow-offset="10" data-wow-duration="1.5s">
         <img class="feature-img mobile-adjust" src="/static/images/product/m1-main.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m1-mainx2.png" alt="" ref="lazyImg" />
       </div>
      <div class="scroll-mouse">
        <img style="width: 30px;height: 30px;" src="/static/images/mouse-w.png"/>
        <p style="color: #FFFFFF;font-size: 12px;margin-top: 10px;">Scroll Mouse</p>
      </div>
    </section>

    <!-- Rich in function Section -->
    <section class="page-content">
      <div class="m1-title-box">
        <p class="text_21 bold-text">Rich in function</p>
        <p style="padding: 0 20px;font-size: 15px;font-family: MiSans-Regular;">You focus on everything</p>
      </div>
      <div class="features-box" data-wow-offset="10" data-wow-duration="1.5s">
        <div class="row m1-function-box">
          <div class="col-lg-3">
            <div class="m1-function-item">
              <img src="/static/images/product/function1.png"/>
              <p>Body composition analysis</p>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="m1-function-item">
              <img src="/static/images/product/function2.png"/>
              <p>Body posture Analysis</p>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="m1-function-item">
              <img src="/static/images/product/function3.png"/>
              <p>Detection Data Analysis</p>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="m1-function-item">
              <img src="/static/images/product/function4.png"/>
              <p>Test Report</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Smart screen Section -->
    <section class="page-content">
      <div class="left-title-box">
        <p class="text_21 bold-text m1-jishen-txt" style="text-align: left;">Smart screen <br>Close at hand</p>
        <p>Immersive body testing<br>IPS HD Touch </p>
      </div>
      <div class="features-box" data-wow-offset="10" data-wow-duration="1.5s">
         <img class="feature-img mobile-adjust" src="/static/images/product/m1-jishen.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m1-jishenx2.png" alt="" ref="lazyImg">
       </div>
    </section>

    <!-- Black tempered glass Section -->
    <section class="page-content">
      <div class="rightM-title-box">
        <p class="text_21 bold-text" style="padding: 0 20px;">Black <br>tempered glass</p>
        <p class="text_center">Highlight the beauty of industrial technology, minimalist high-end fashion</p>
      </div>
      <div class="features-box" data-wow-offset="10" data-wow-duration="1.5s">
         <img class="feature-img mobile-adjust" src="/static/images/product/m3-dizuo.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m1-dizuox2.png" alt="" ref="lazyImg">
       </div>
    </section>

    <!-- Electrode grip Section -->
    <section class="page-content">
      <div class="m1-title-box txt-shoubing" style="position: relative; top: 35vh;z-index: 2;">
        <p class="text_21 bold-text" style="text-align: center;">Electrode&nbsp;grip&nbsp;3.0</p>
        <p class="text_center">Ergonomic design,designed for physical measurement, fully fit the curve of the palm</p>
      </div>
      <div class="features-box" data-wow-offset="10" data-wow-duration="1.5s">
         <img class="feature-img mobile-adjust" src="/static/images/product/m1-shoubing.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m1-shoubingx2.png" alt="" ref="lazyImg">
       </div>
    </section>

    <!-- Multi-core power cord Section -->
    <section class="page-content">
      <div class="left-title-box">
        <p class="text_21 bold-text" style="text-align: left;">Multi-core <br>power cord</p>
        <p>High-precision multi-core wire harness is used to ensure the <br>safety of human detection and obtain accurate data</p>
      </div>
      <div class="features-box" data-wow-offset="10" data-wow-duration="1.5s">
         <img class="feature-img mobile-adjust" src="/static/images/product/m1-xiancai.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m1-xiancaix2.png" alt="" ref="lazyImg">
         <p class="txt-xiancai">The voltage through the human body during the detection is 1V</p>
       </div>
    </section>

    <!-- Body composition analysis Section -->
    <section class="page-content">
      <div class="bottom-title-box txt-shoubing" style="top: 40vh;">
        <p class="text_21 bold-text">Body composition analysis</p>
        <p class="text_center">Gender and age differences were excluded based on real impedance measurements</p>
      </div>
      <div class="features-box" data-wow-offset="10" data-wow-duration="1.5s">
         <img class="feature-img mobile-adjust" src="/static/images/product/m1-body.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m1-bodyx2.png" alt="" ref="lazyImg">
       </div>
    </section>

    <!-- Pose analysis Section -->
    <section class="page-content">
      <div class="row" style="height: calc(100vh - 90px);">
        <div class="col-lg-7">
          <img class="m1-tzt-img mobile-adjust" src="/static/images/product/m1-jishen.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m1-tztx2.png" alt="" ref="lazyImg">
        </div>
        <div class="col-lg-5">
          <div class="m1-tzt-txt">
            <p class="text_21 bold-text">Pose analysis</p>
            <p>
              Using a high-precision AI camera, combined with the big data <br>
              analysis of human skeleton points in the cloud, the posture <br>
              risks of human high and low shoulders, O-legs, scoliosis, head tilt, <br>
              hunchback, pelvis forward, knee hyperextension and so on are evaluated.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- M1 color Section -->
    <section class="page-content">
      <div class="m1-title-box txt-shoubing">
        <p class="text_21 bold-text" style="text-align: center;">M1 color</p>
      </div>
      <div class="features-box m1-color-bg" data-wow-offset="10" data-wow-duration="1.5s">
        <div class="m1-color-box">
          <div class="btn-color">
            <div id="btn-left">◀</div>
            <div id="btn-right">▶</div>
          </div>
          <div class="m1-color-item" id="allM1">
            <img class="m1-color-img m1-color-all" src="/static/images/product/m1-main.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m1-allx2.png" alt="" ref="lazyImg">
          </div>
          <div class="m1-color-item animated fadeInRightBig" id="whiteM1">
            <img class="m1-color-img m1-white" src="/static/images/product/m1-white.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m1-white2x.png" alt="" ref="lazyImg">
          </div>
          <div class="m1-color-item animated fadeInLeftBig" id="blackM1">
            <img class="m1-color-img m1-black" src="/static/images/product/m1-black.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m1-black2x.png" alt="" ref="lazyImg">
          </div>
        </div>
      </div>
    </section>

    <!-- Industrial high precision sensor Section -->
    <section class="page-content">
      <div class="leftT-title-box txt-shoubing">
        <p class="text_21 bold-text" style="text-align: left !important;padding-left: 20px;">Industrial high <br>precision sensor</p>
        <p class="text_center" style="text-align: left;">Accurately&nbsp;measure&nbsp;the&nbsp;weight&nbsp;per&nbsp;gram&nbsp;of&nbsp;the&nbsp;human&nbsp;body&nbsp;and <br>
        the&nbsp;resistivity&nbsp;change&nbsp;per&nbsp;ohm&nbsp;to&nbsp;ensure&nbsp;the&nbsp;accuracy&nbsp;and&nbsp;stability<br>
        of&nbsp;the&nbsp;measurement&nbsp;results</p>
      </div>
      <div class="features-box" data-wow-offset="10" data-wow-duration="1.5s">
        <img class="feature-img mobile-adjust" src="/static/images/product/m3-xinpian.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m3-xinpianx2.png" alt="" ref="lazyImg">
      </div>
    </section>

    <!-- ANOVATOR AI Section -->
    <section class="page-content">
      <div class="rightM-title-box txt-shoubing">
        <p class="text_21 bold-text" style="text-align: left !important;padding-left: 20px;">ANOVATOR AI</p>
        <p class="text_center" style="text-align: left;">Powerful data computing power escorts the <br>accuracy of physical measurement.</p>
      </div>
      <div class="features-box" data-wow-offset="10" data-wow-duration="1.5s">
        <img class="feature-img mobile-adjust" src="/static/images/product/m1-ai.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m1-aix2.png" alt="" ref="lazyImg">
      </div>
    </section>

    <!-- PC background management system Section -->
    <section class="page-content">
      <div class="m1-csbg-title">
        PC background <br>management system
      </div>
      <div class="features-box" data-wow-offset="10" data-wow-duration="1.5s">
        <img class="feature-img2 mobile-adjust" src="/static/images/product/m1-csbg.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m1-csbgx2.png" alt="" ref="lazyImg">
      </div>
    </section>

    <!-- Technical Specifications Section -->
    <div class="container" style="margin-top: 25vh;">
      <div class="tb-title">
        TECHNICAL SPECIFICATIONS:
      </div>
      
      <table class="tb technical-tb">
        <tr v-for="(row, index) in technicalSpecs" :key="index">
          <td class="tb-key">{{ row.left }}</td>
          <td class="tb-key">{{ row.right }}</td>
        </tr>
      </table>
      
      <h4 style="margin-top: 50px;margin-bottom: 20px;color: #FFFFFF;">M1 Body Composition Analyzer</h4>
      <table class="tb product-parameters">
        <tr v-for="(param, index) in productParams" :key="index">
          <td v-if="param.category" class="tb-col1" :rowspan="param.rowspan">{{ param.category }}</td>
          <td class="tb-col2">{{ param.name }}</td>
          <td class="tb-col3" v-html="param.value"></td>
        </tr>
      </table>
    </div>


    <!-- 3D Product View Section -->
    <div style="background-color: #f8f9fa; padding: 60px 0; margin-top: 150px; margin-bottom: 0;">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <h2 style="text-align: center; margin-bottom: 30px; color: #333; font-weight: bold;text-transform: uppercase;">M1 3D Product View</h2>
            <div style="text-align: center; margin-bottom: 20px;">
              <button id="btn-white-3d" class="btn" style="background: #fff; color: #333; border: 2px solid #ddd; margin-right: 10px; padding: 8px 20px; border-radius: 25px; font-weight: bold;">White Version</button>
              <button id="btn-black-3d" class="btn" style="background: #333; color: #fff; border: 2px solid #333; padding: 8px 20px; border-radius: 25px; font-weight: bold;">Black Version</button>
            </div>
            <div style="background: white; border-radius: 15px; box-shadow: 0 10px 30px rgba(0,0,0,0.1); padding: 20px; max-width: 1200px; margin: 0 auto;">
              <iframe id="product-3d-iframe" src="/static/web/m1/m1_white.html" 
                width="100%" 
                height="700px" 
                style="border: none; border-radius: 10px; min-height: 300px;"
                frameborder="0">
              </iframe>
              <p style="text-align: center; margin-top: 15px; color: #666; font-size: 14px;">Drag to rotate • Double-click for fullscreen</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'M1',
  data() {
    return {
      technicalSpecs: [
        { left: 'User ID Login/Phone Number Login', right: 'On Screen Results' },
        { left: 'Printable Results', right: 'Handle Grips' },
        { left: 'Weight', right: 'BMI' },
        { left: 'Body Fat Percentage', right: 'Muscle Mass' },
        { left: 'Visceral Fat Area', right: 'Subcutaneous Fat Area' },
        { left: 'Protein Content', right: 'Total Body Water' },
        { left: 'Skeletal Muscle', right: 'Fat-Free Body' },
        { left: 'Bone Mass', right: 'WHR' },
        { left: 'Body Age', right: 'BMR(kcal)' },
        { left: 'Obesity Degree (%)', right: 'Desirable Weight' },
        { left: 'Weight Control', right: 'Fat Control' },
        { left: 'Muscle Control', right: 'Segmental Muscle' },
        { left: 'Segmental Body Fat', right: 'Body Type Classification' },
        { left: 'Body Posture Analysis', right: 'Total Energy Expenditure (kcal)' },
        { left: 'Calorie Consumption (kcal/hour)', right: 'Expected Fat Burning (kg)' },
        { left: 'Target Body Fat', right: 'Exercise Program Advice' },
        { left: 'Estimated Completion Period', right: 'Body Composition History' },
        { left: 'Pervious Data Comparison', right: '' }
      ],
      productParams: [
        { category: 'Basic Info', rowspan: 5, name: 'Brand', value: 'ANOVATOR' },
        { name: 'Product Name', value: 'M1 Body Composition Analyzer' },
        { name: 'Model', value: 'M1' },
        { name: 'Color', value: 'White / Black' },
        { name: 'Operating System', value: 'Android 7.1' },
        { category: 'Hardware', rowspan: 3, name: 'Camera', value: '2MP HD Camera' },
        { name: 'Material', value: 'Tempered Glass + ABS' },
        { name: 'Dimensions & Weight', value: '350×350×25mm, 8kg' },
        { category: 'Display', rowspan: 1, name: 'Screen', value: '21.5" IPS Touch Screen, 1080×1920' },
        { category: 'Technical Parameters', rowspan: 4, name: 'Measurement Range', value: '5-300kg' },
        { name: 'Accuracy', value: '±0.1kg' },
        { name: 'Frequency', value: '50kHz, 250kHz' },
        { name: 'Measurement Time', value: '< 60 seconds' },
        { category: 'Functional Parameters', rowspan: 3, name: 'Body Composition', value: 'Weight, BMI, Body Fat, Muscle Mass, etc.' },
        { name: 'Posture Analysis', value: 'AI-powered posture assessment' },
        { name: 'Data Storage', value: 'Cloud storage & local backup' },
        { category: 'Environment', rowspan: 2, name: 'Operating Environment', value: '10°C-40°C, 30%-75%RH' },
        { name: 'Storage Environment', value: '-20°C-60°C, ≤85%RH' }
      ]
    }
  },
  mounted() {
    document.title = 'M1 - Anovator';
    // 延迟初始化懒加载，确保页面滚动位置已恢复
    this.$nextTick(() => {
      setTimeout(() => {
        this.initLazyLoading();
      }, 100);
    });
    this.init3DControls();
  },
  
  beforeUnmount() {
    // 清理事件监听器和observer
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
      window.removeEventListener('resize', this.scrollHandler);
    }
    if (this.imageObserver) {
      this.imageObserver.disconnect();
    }
  },
  methods: {
    initLazyLoading() {
      // 首先确保所有图片都显示src中的默认图片
      const images = this.$el.querySelectorAll('img[data-src]');
      images.forEach(img => {
        img.style.opacity = '1';
        img.classList.remove('lazy');
      });

      // 存储observer引用以便后续使用
      this.imageObserver = null;

      if ('IntersectionObserver' in window) {
        this.imageObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const img = entry.target;
              if (img.dataset.src && !img.dataset.loaded) {
                this.loadHighResImage(img);
                this.imageObserver.unobserve(img);
              }
            }
          });
        }, {
          rootMargin: '200px 0px', // 增大预加载范围
          threshold: [0, 0.1, 0.5] // 多个阈值确保更好的触发
        });

        images.forEach(img => {
          this.imageObserver.observe(img);
        });

        // 延迟执行初始视口检查，确保页面完全渲染
        setTimeout(() => {
          this.checkImagesInViewport(images);
        }, 200);

        // 添加滚动事件监听作为备用机制
        this.scrollHandler = this.throttle(() => {
          this.checkImagesInViewport(images);
        }, 100);
        
        window.addEventListener('scroll', this.scrollHandler, { passive: true });
        window.addEventListener('resize', this.scrollHandler, { passive: true });
      } else {
        // Fallback for browsers that don't support IntersectionObserver
        images.forEach(img => {
          if (img.dataset.src && !img.dataset.loaded) {
            this.loadHighResImage(img);
          }
        });
      }
    },
    
    checkImagesInViewport(images) {
      images.forEach(img => {
        if (img.dataset.src && !img.dataset.loaded) {
          const rect = img.getBoundingClientRect();
          const windowHeight = window.innerHeight || document.documentElement.clientHeight;
          const isInViewport = rect.top < windowHeight + 200 && rect.bottom > -200;
          
          if (isInViewport) {
            this.loadHighResImage(img);
            if (this.imageObserver) {
              this.imageObserver.unobserve(img);
            }
          }
        }
      });
    },
    
    throttle(func, limit) {
      let inThrottle;
      return function() {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
          func.apply(context, args);
          inThrottle = true;
          setTimeout(() => inThrottle = false, limit);
        }
      }
    },
    loadHighResImage(img) {
      const highResImg = new Image();
      
      highResImg.onload = () => {
        // 无缝切换到高清图片
        img.style.transition = 'opacity 0.3s ease-in-out';
        img.style.opacity = '0.7';
        
        setTimeout(() => {
          img.src = img.dataset.src;
          img.dataset.loaded = 'true';
          img.style.opacity = '1';
        }, 150);
      };
      
      highResImg.onerror = () => {
        // 如果高清图片加载失败，保持使用默认图片
        console.warn('Failed to load high-res image, keeping default:', img.dataset.src);
        img.dataset.loaded = 'true';
      };
      highResImg.src = img.dataset.src;
    },
    init3DControls() {
      this.$nextTick(() => {
        // 3D控制逻辑
        const btnWhite = document.getElementById('btn-white-3d');
        const btnBlack = document.getElementById('btn-black-3d');
        const iframe = document.getElementById('product-3d-iframe');
        
        if (btnWhite && btnBlack && iframe) {
          btnWhite.addEventListener('click', () => {
            iframe.src = '/static/web/m1/m1_white.html';
            btnWhite.style.background = '#fff';
            btnWhite.style.color = '#333';
            btnBlack.style.background = 'transparent';
            btnBlack.style.color = '#333';
          });
          
          btnBlack.addEventListener('click', () => {
            iframe.src = '/static/web/m1/m1_black.html';
            btnBlack.style.background = '#333';
            btnBlack.style.color = '#fff';
            btnWhite.style.background = 'transparent';
            btnWhite.style.color = '#333';
          });
        }
        
        // M1颜色切换逻辑
        const btnLeft = document.getElementById('btn-left');
        const btnRight = document.getElementById('btn-right');
        const allM1 = document.getElementById('allM1');
        const whiteM1 = document.getElementById('whiteM1');
        const blackM1 = document.getElementById('blackM1');
        
        if (btnLeft && btnRight && allM1 && whiteM1 && blackM1) {
          // 初始状态：隐藏白色和黑色，显示全部
          whiteM1.style.display = 'none';
          blackM1.style.display = 'none';
          allM1.style.display = 'block';
          
          btnLeft.addEventListener('click', () => {
            allM1.style.display = 'none';
            blackM1.style.display = 'none';
            whiteM1.style.display = 'block';
            btnLeft.classList.add('m1-color-active');
            btnRight.classList.remove('m1-color-active');
          });
          
          btnRight.addEventListener('click', () => {
            allM1.style.display = 'none';
            whiteM1.style.display = 'none';
            blackM1.style.display = 'block';
            btnLeft.classList.remove('m1-color-active');
            btnRight.classList.add('m1-color-active');
          });
        }
      });
    }
  }
}
</script>

<style scoped>
.m1-page {
  background-color: #000;
  color: #fff;
  font-family: 'Arial', sans-serif;
}

.page-content {
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
}

/* Hero Section Styles */
.title-box {
  position: absolute;
  width: 100%;
  top: 9vh;
  text-align: center;
  z-index: 10;
}

.section_21 {
  position: absolute;
  top: 10%;
  left: 5%;
  z-index: 10;
}

.text_7 {
  font-size: 60px;
  font-weight: bold;
  line-height: 1.2;
  color: #fff;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
}

.m1-line {
  width: 100px;
  height: 4px;
  background: linear-gradient(90deg, #ff6b6b, #4ecdc4);
  margin-top: 20px;
}

.section_22 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 5;
}

.text_9 {
  position: relative;
  width: 27.57vw;
  height: 2.23vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.66vw;
  text-transform: uppercase;
  font-family: MiSans-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 2.23vw;
  top: 80vh;
  left: 5vw;
}

.text_10 {
  position: relative;
  width: 34.17vw;
  height: 8.89vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 3.33vw;
  text-transform: uppercase;
  font-family: MiSans-Bold;
  font-weight: 700;
  text-align: left;
  line-height: 4.45vw;
  top: 15vh;
  left: 10vw;
}

.text_11 {
  font-size: 120px;
  font-weight: bold;
  color: #fff;
  text-shadow: 3px 3px 6px rgba(0,0,0,0.7);
}

.features-box {
  width: 100%;
  text-align: center;
  position: relative;
}

.scroll-mouse {
  position: absolute;
  left: 50%;
  bottom: 12%;
  transform: translateX(-50%);
  text-align: center;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateX(-50%) translateY(0);
  }
  40% {
    transform: translateX(-50%) translateY(-10px);
  }
  60% {
    transform: translateX(-50%) translateY(-5px);
  }
}

/* Title Boxes */
.m1-title-box {
  text-align: center;
  margin-bottom: 60px;
}

.left-title-box {
  position: absolute;
  left: 5%;
  top: 20%;
  text-align: left;
  z-index: 10;
}

.rightM-title-box {
  position: absolute;
  right: 5%;
  top: 20%;
  text-align: center;
  z-index: 10;
}

.bottom-title-box {
  position: absolute;
  width: 100%;
  text-align: center;
  text-align: center;
  z-index: 10;
}

.leftT-title-box {
  position: absolute;
  left: 5%;
  top: 15%;
  text-align: left;
  z-index: 10;
}

.text_21 {
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 20px;
  line-height: 1.2;
}

.bold-text {
  font-weight: 900;
  text-transform: uppercase;
}

.text_center {
  text-align: center;
}

/* Function Section */
.m1-function-box {
  margin-top: 40px;
  width: 80%;
  margin: 0 auto;
}

.m1-function-item {
  text-align: center;
  padding: 20px;
}

.m1-function-item img {
  width: 80px;
  height: 80px;
  margin-bottom: 15px;
}

.m1-function-item p {
  font-size: 16px;
  color: #fff;
  margin: 0;
}

/* Pose Analysis Section */
.m1-tzt-img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.m1-tzt-txt {
  padding: 60px 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.m1-tzt-txt p {
  line-height: 1.6;
  margin-bottom: 20px;
}

/* M1颜色选择样式 */
.m1-color-bg {
  position: relative;
  background-image: url('@/assets/m1-color-bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: calc(100vh - 90px);
}

.m1-color-box {
  position: relative;
  width: 70%;
  z-index: 2;
  margin: 0 auto;
  display: flex;
  top: 15vh;
}

.btn-color {
  position: absolute;
  width: 50px;
  height: 50px;
  line-height: 48px;
  text-align: center;
  top: 50%;
  left: 48%;
  z-index: 10;
  border-radius: 50%;
  font-size: 18px;
  background-color: #000000;
  border: 1px solid #3F3F3F;
  color: #FFFFFF;
  display: flex;
}

.btn-color div {
  display: inline-block;
  width: 50%;
  cursor: pointer;
}

.btn-color div:hover {
  color: #EF0A6A;
}

.m1-color-active {
  color: #EF0A6A;
}

.m1-color-item {
  position: relative;
  width: 100%;
  background-color: #555;
  text-align: center;
}

.m1-color-img {
  position: relative;
  width: 100%;
  max-width: 100%;
  height: auto;
}

/* PC Background Management */
.m1-csbg-title {
  position: absolute;
  top: 15%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 48px;
  font-weight: bold;
  text-align: center;
  z-index: 10;
  line-height: 1.2;
  text-transform: uppercase;
}

.feature-img2 {
  max-width: 90%;
  height: auto;
  object-fit: contain;
}

/* Special Text Styles */
.txt-xiancai {
  position: absolute;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 18px;
  color: #ffd700;
  text-align: center;
  background: rgba(0,0,0,0.7);
  padding: 10px 20px;
  border-radius: 25px;
}

.txt-shoubing {
  margin-bottom: 80px;
  top: 50vh;
  
}

.m1-jishen-txt {
  font-size: 52px !important;
}

/* Table Styles */
.tb-title {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  margin: 80px 0 30px 0;
  text-align: center;
}

.tb {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 40px;
  overflow: hidden;
}

.tb td {
  padding: 15px 20px;
  border: 1px solid rgba(255,255,255,0.2);
  color: #fff;
}

.tb-key {
  background: rgba(255,255,255,0.05);
  background-image: url('../../../public/static/images/checkmark.png');
  background-repeat: no-repeat;
  background-size: 22px;
  background-position-y: 50%;
  background-position-x: 97%;
  padding-right: 30px;
}

.tb-col1 {
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
}


.tb-col3 {
  background: rgba(255,255,255,0.02);
}

/* 懒加载样式 */
img[data-src] {
    transition: opacity 0.3s ease-in-out;
  }

  img[data-src]:not([src]) {
    min-height: 200px;
    background: #f5f5f5;
  }

/* Responsive Design */
@media (max-width: 768px) {
  .text_7 {
    font-size: 36px;
  }
  
  .text_11 {
    font-size: 72px;
  }
  
  .text_21 {
    font-size: 32px;
  }
  
  .m1-jishen-txt {
    font-size: 36px !important;
  }
  
  .m1-csbg-title {
    font-size: 32px;
  }
  
  .left-title-box,
  .rightM-title-box,
  .leftT-title-box {
    position: relative;
    left: auto;
    right: auto;
    top: auto;
    transform: none;
    text-align: center;
    margin-bottom: 40px;
    padding: 20px;
  }
  
  .section_21 {
    position: relative;
    top: auto;
    left: auto;
    text-align: center;
    margin-bottom: 40px;
  }
  
  .section_22 {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
    margin-bottom: 40px;
  }
  
  .m1-tzt-txt {
    padding: 20px;
  }
  
  .mobile-adjust {
    max-width: 95%;
  }
  
  .m1-function-box {
    margin-top: 20px;
  }
  
  .m1-function-item {
    margin-bottom: 30px;
  }
  
  .tb td {
    padding: 10px;
    font-size: 14px;
  }
  
  .tb-key {
    background-size: 16px;
    background-position-x: 95%;
    padding-right: 20px;
  }
}

@media (max-width: 480px) {
  .text_7 {
    font-size: 28px;
  }
  
  .text_11 {
    font-size: 48px;
  }
  
  .text_21 {
    font-size: 24px;
  }
  
  .m1-csbg-title {
    font-size: 24px;
  }
}

/* 4K and large screen optimization */
@media (min-width: 1920px) {
  .feature-img, .feature-img2 {
    width: 100vw !important;
    max-width: none !important;
    margin-left: calc(-50vw + 50%) !important;
    margin-right: calc(-50vw + 50%) !important;
  }
  
  .features-box {
    width: 100vw !important;
    margin-left: calc(-50vw + 50%) !important;
    margin-right: calc(-50vw + 50%) !important;
  }
  
  .m1-color-img {
    width: 100vw !important;
    max-width: none !important;
    margin-left: calc(-50vw + 50%) !important;
    margin-right: calc(-50vw + 50%) !important;
  }
}
</style>